import { ComponentType } from "react";
import DateField from "pages/common/Analytics/components/Reports/components/ReportForm/components/DateField/DateField";
import MultiselectField from "pages/common/Analytics/components/Reports/components/ReportForm/components/MultiselectField/MultiselectField";
import FreightModeField from "pages/common/Analytics/components/Reports/components/ReportForm/components/FreightModeField/FreightModeField";
import AdditionalDetailField from "pages/common/Analytics/components/Reports/components/ReportForm/components/AdditionalDetailField/AdditionalDetailField";
import ReportType from "../../ReportType";
import { reportShipmentOptions } from "./reportCustomOptions";

interface ReportField {
  component: ComponentType<any>; // ComponentType for the React component
  props?: Record<string, any>; // Optional props for the component
}

type ReportFields = {
  [key in ReportType]: ReportField[];
};

const REPORT_FIELDS = (intl: any, paymentLocations: any, co2EmissionEnabled: any): ReportFields => ({
  [ReportType.QUICK_REQUEST]: [
    { component: DateField },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.REQUESTS]: [
    { component: DateField },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.SHIPMENTS]: [
    { component: DateField, props: { useGroupBy: true } },
    {
      component: MultiselectField,
      props: {
        name: "request_details",
        label: intl.formatMessage({ id: "report.request", defaultMessage: "Request" }),
        description: intl.formatMessage({ id: "report.chooseRequestDetails", defaultMessage: "Choose request details" }),
        options: reportShipmentOptions(intl, co2EmissionEnabled),
        minSelected: 1,
      },
    },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.QUOTES]: [
    { component: DateField },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
    { component: AdditionalDetailField },
  ],
  [ReportType.INVOICES]: [
    { component: DateField, props: { useGroupBy: true } },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.CHARGECODES]: [
    { component: DateField },
    {
      component: MultiselectField,
      props: {
        name: "payment_locations",
        label: intl.formatMessage({ id: "report.paymentLocation", defaultMessage: "Payment location" }),
        description: intl.formatMessage({ id: "report.chooseLocations", defaultMessage: "Choose locations" }),
        options: paymentLocations,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
});

export default REPORT_FIELDS;
